import React, { Component } from 'react'
import './InstantBookingQa.scss'
import DetailsItem from '../Details/DetailsItem'

class InstantBookingQa extends Component {

    constructor(props) {
        super(props)
    }

    static propTypes = {
        containerClassName: React.PropTypes.string,
    }

    render() {
        return (
            <section className="InstantBookingQa">
                <div className={this.props.containerClassName || "container"}>
                    <DetailsItem title="Если я не хочу платить полную стоимость сейчас?">
                        Обратитесь в службу поддержки Везёт Всем по телефону 8 800 555-19-23.
                    </DetailsItem>
                    <DetailsItem title="За сколько часов я могу отказаться от перевозки?">
                        Мы вернем полную стоимость перевозки, если вы откажетесь не позднее 5 часов до начала
                        погрузки.
                    </DetailsItem>
                    <DetailsItem title="Где ознакомиться с договором перевозки?">
                        Сейчас вам доступен пример договора на перевозку. После бронирования транспорта и назначения
                        машины вам будет доступен полноценный договор перевозки. Он будет отправлен вам на
                        электронную почту, в смс и всегда доступен в личном кабинете на сайте.
                    </DetailsItem>
                    <DetailsItem title="Примеры перевозок и отзывы">
                        Везёт Всем с 2010 года на рынке грузоперевозок. За это время мы перевозили разные грузы от
                        милых котят до частей самолетов. Отзывы и примеры перевозок доступны
                        <a target='_blank' href='/otzyvy'>на странице</a>.
                    </DetailsItem>
                </div>
            </section>
        )
    }
}

export default InstantBookingQa



// WEBPACK FOOTER //
// ./client/components/InstantBookingQa/InstantBookingQa.js